export default "Lav lyde med de naturmaterialer I kan finde. Eller brug jeres hjemmelavede instrumenter og dan jeres eget stenalder-band!";